import gql from "graphql-tag";

export const uploadProfilePicture = gql`
  query {
    uploadProfilePicture {
      presignedUrl
    }
  }
`;

export const uploadProfilePictureOptions = {
  name: "uploadProfilePicture",
};
